import {
  type CardDraftBulkImport,
  type BulkImportStore,
} from '@/components/BulkImportModal/store/bulk-import.store.types'
import {
  BASE_REPEAT_FIELD_VALUES,
  type CardActivityType,
  type CardActivityWithId,
} from '@/models/card-activity/card-activity.model'
import translateText from '@/utils/translateText'

export async function enrichRepeatCard(
  cardType: CardActivityType,
  cardDraft: CardDraftBulkImport & { id: string },
  settings: BulkImportStore['settings'],
) {
  const baseRepeatCard: Partial<CardActivityWithId> = {
    repeat: BASE_REPEAT_FIELD_VALUES.repeat,
    id: cardDraft.id,
    type: cardType,
    verificationStatus: null,
    checked: false,
    target_text: cardDraft.prompt,
    native_text: cardDraft.native_text,
    language: settings.language,
    default_language: settings.defaultLanguage,
    points: settings.points,
    difficulty: settings.grading.leniency,
  }

  if (settings.generateTranslations && cardDraft.native_text === '') {
    const translatedText = await translateText({
      target_text: cardDraft.prompt,
      toLanguage: settings.defaultLanguage,
      language: settings.language,
    })

    baseRepeatCard.native_text = translatedText
  }

  return baseRepeatCard
}
